import { post } from "./base";

export async function getGate(accessToken, videoId) {
  return await post("learning/GetGate", { jsonBody: { accessToken, videoId } });
}

export async function startVideoProgress(accessToken, videoId) {
  return await post("learning/StartVideoProgress", { jsonBody: { accessToken, videoId } });
}

export async function recordVideoProgress(accessToken, sessionId, positionSec) {
  return await post("learning/RecordVideoProgress", { jsonBody: { accessToken, sessionId, positionSec } });
}

export async function markCompleted(accessToken, videoId, sessionId) {
  return await post("learning/MarkCompleted", { jsonBody: { accessToken, videoId, sessionId } });
}

export async function getVideos(accessToken, userId) {
  return await post("learning/GetVideos", { jsonBody: { accessToken, userId } });
}

export async function setVideo(accessToken, video) {
  const { videoId, title, url, durationSec, active } = video;
  return await post("learning/SetVideo", { jsonBody: { accessToken, videoId, title, url, durationSec, active } });
}

export async function getVideoTargets(accessToken, videoId) {
  return await post("learning/GetVideoTargets", { jsonBody: { accessToken, videoId } });
}

export async function setVideoTargets(accessToken, videoId, targetIds) {
  return await post("learning/SetVideoTargets", { jsonBody: { accessToken, videoId, targetIds } });
}

export async function uploadVideo(accessToken, file) {
  const fd = new FormData();
  fd.set("file", file);
  fd.set("accessToken", accessToken);
  return await post("learning/UploadVideo", { accessToken, formBody: fd });
}

export async function listDiskVideos(accessToken) {
  return await post("learning/ListVideosOnDisk", { jsonBody: { accessToken } });
}

export async function getAvailableVideos(accessToken) {
  return await post("learning/GetAvailableVideos", { jsonBody: { accessToken } });
}

export async function deleteVideo(accessToken, videoId) {
  return await post("learning/DeleteVideo", { jsonBody: { accessToken, videoId } });
}

export async function deleteVideoFile(accessToken, videoUrl) {
  return await post("learning/DeleteVideoFile", { jsonBody: { accessToken, url: videoUrl } });
}

export async function setQuiz(accessToken, quiz) {
  const { id, videoId, title } = quiz || {}
  const json = JSON.stringify(quiz || {})
  return await post("learning/SetQuiz", { jsonBody: { accessToken, quizId: id, videoId, title, json } })
}

export async function getQuizByVideo(accessToken, videoId) {
  
  return await post("learning/GetQuizByVideo", { jsonBody: { accessToken, videoId } })
}

export async function deleteQuiz(accessToken, { videoId, quizId }) {
  return await post("learning/DeleteQuiz", { jsonBody: { accessToken, videoId, quizId } })
}

export async function getQuizResults(accessToken, { videoId, quizId, userId } = {}) {
  const jsonBody = { accessToken };
  if (videoId !== undefined) jsonBody.videoId = videoId;
  if (quizId !== undefined) jsonBody.quizId = quizId;
  if (userId !== undefined) jsonBody.userId = userId;
  return await post("learning/GetQuizResults", { jsonBody });
}

export async function getUsers(accessToken) {
  return await post("learning/GetUsers", { jsonBody: { accessToken } });
}

export async function submitQuizResult(accessToken, result) {
  const { videoId, quizId, answersJson, durationSec } = result || {}
  return await post("learning/SubmitQuizResult", { jsonBody: { accessToken, videoId, quizId, answersJson, durationSec } })
}
